<template>
  <v-layout row justify-center>
    <v-dialog persistent v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title :class="modalType ? modalType + ' white--text' : ''" primary-title>
          <span class="headline">{{defaults.title}}</span>
        </v-card-title>
        <v-card-text v-html="message"></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            :loading="loading && loading === true ? true : false"
            text
            @click="$emit('choose', true)"
          >{{defaults.confirmLabel}}</v-btn>
          <v-btn color="blue darken-1" text @click="$emit('choose', false)">{{defaults.cancelLabel}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
export default {
  name: 'app-confirm-modal',
  props: [
    'title',
    'message',
    'confirmLabel',
    'cancelLabel',
    'dialog',
    'modalType',
    'loading'
  ],
  data() {
    return {
      defaults: {
        confirmLabel: 'Sim',
        cancelLabel: 'Não',
        title: 'Atenção!'
      }
    }
  },
  mounted() {}
}
</script>